const url          = new URL(window.location.href);
const params       = new URLSearchParams(url.search);
const category     = params.get('c');
const headerIn     = document.querySelector('.headerUserInitails');
const filterExpand = document.querySelector('.filterExpand');
const filterL      = document.querySelectorAll('.filterList input');
const bodyClasses  = document.querySelector('body').classList;
const titleWrapper = document.querySelector('.rolling-headline-wrapper');
const tabWrapper   = document.querySelector('.tabPaneWrapper');
const nav          = document.querySelector('.productTab .nav-tabs');

let moreLink = null;

function isMobile() {
  return window.innerWidth <= 768;
}


//HomePage Functions
function productTabFilter(){
  let sType   = Array.from(document.querySelectorAll('#typeFilter input:checked')).flatMap(x => x.value);
  let sTag    = Array.from(document.querySelectorAll('#phaseFilter input:checked')).flatMap(x => x.value);
  let sVendor = Array.from(document.querySelectorAll('#vendorFilter input:checked')).flatMap(x => x.value);
  sType   = sType.length     === 0 ? ['Pathways', 'Wearables', 'Supplements', 'Test'] : sType;
  sTag    = sTag.length      === 0 ? ['Screening', 'Chronische', 'Therapie'] : sTag;
  sVendor = sVendor.length   === 0 ? ['myon.clinic', '-'] : sVendor;
  let sPathOnly = ['Pathways'];
  let sNoVendorOnly = ['myon.clinic'];
  if(sType.includes('Pathways') && sVendor.includes('myon.clinic')) document.querySelectorAll('.pathwaysSection').forEach(el => el.classList.remove('d-none'));
  else document.querySelectorAll('.pathwaysSection').forEach(el => el.classList.add('d-none'));
  
  if(sType.every(type => sPathOnly.includes(type))) document.querySelectorAll('.productsSection').forEach(el => el.classList.add('d-none'));
  else if(sVendor.every(type => sNoVendorOnly.includes(type))) document.querySelectorAll('.productsSection').forEach(el => el.classList.add('d-none'));  
  else document.querySelectorAll('.productsSection').forEach(el => el.classList.remove('d-none'));
  document.querySelectorAll('.product-card--style10').forEach(el => {
    let pVendor = el.getAttribute("vendor") == 'myon.clinic' ? 'myon.clinic' : '-';
    if(sType.includes(el.getAttribute("type")) && sTag.includes(el.getAttribute("phase")) && sVendor.includes(pVendor)) el.closest('.producttab-item').classList.remove('d-none');
    else el.closest('.producttab-item').classList.add('d-none');
  });
}
function setupPagination(containerSelector, itemsPerPage = (isMobile() ? 6 : 12)) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const items = container.querySelectorAll('.producttab-item');
  const totalItems = items.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  let currentPage = 1;

  const paginationWrapper = document.createElement('div');
  paginationWrapper.classList.add('mxPagination');

  function renderPagination() {
    paginationWrapper.innerHTML = '';
    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement('button');
      btn.textContent = i;
      btn.className = 'mxPagination-button';
      if (i === currentPage) btn.classList.add('active');
      btn.addEventListener('click', () => {
        currentPage = i;
        showPage();
        renderPagination();
      });
      paginationWrapper.appendChild(btn);
    }
  }

  function showPage() {
    items.forEach((item, index) => {
      item.style.display =
        index >= (currentPage - 1) * itemsPerPage && index < currentPage * itemsPerPage
          ? ''
          : 'none';
    });
  }
  showPage();
  renderPagination();
  container.appendChild(paginationWrapper);
}
function specialDescFn(collection){
  let cName = collection.getAttribute("cname");
  if(cName === 'Alle Produkte'){
    let sDescs = document.querySelectorAll('.productCardDesc.special');
    let mDescs = document.querySelectorAll('.productCardDesc:not(.special)');
    sDescs.forEach(desc => desc.classList.add('hide'));
    mDescs.forEach(desc => desc.classList.remove('hide'));
  }else{
    let cCards = document.querySelectorAll('.product-card:has(.special[collection='+cName+'])');
    cCards.forEach(card =>{
      let descs = card.querySelectorAll('.productCardDesc');
      descs.forEach(desc => desc.classList.add('hide'));
      card.querySelector('.special[collection='+cName+']').classList.remove('hide')
    })
  }
}
function updateNavState() {
  let toggleLink = document.querySelector('.mx-view-more');
  if(toggleLink){
    if (!isMobile()) {
      nav.classList.remove('mx-collapsed');
      toggleLink.style.display = 'none';
      return;
    }
    
    nav.classList.add('mx-collapsed');
    toggleLink.style.display = 'block';

    if (!nav.classList.contains('mx-expanded')) {
      nav.classList.add('mx-collapsed');
      toggleLink.textContent = 'Mehr anzeigen';
    }
  }
}
function setupHP(){

  if(filterExpand) filterExpand.addEventListener('click', () => document.querySelector('#filterLists').classList.toggle('shown'));
  if(filterL) filterL.forEach(el => el.addEventListener('change', productTabFilter));
  if(category && document.querySelector('.nav-link.'+category)) setTimeout(() => document.querySelector('.nav-link.'+category).click(), 500);
  if(document.querySelector('.pathwaysSection')) setupPagination('.pathwaysSection');
  if(document.querySelector('.productsSection')) setupPagination('.productsSection');
  
  let toggleLink = document.createElement('div');
  toggleLink.className = 'mx-view-more';
  toggleLink.textContent = 'Mehr anzeigen';
  nav.after(toggleLink);  
  toggleLink.addEventListener('click', () => {
    const isExpanded = nav.classList.contains('mx-expanded');

    if (isExpanded) {
      nav.classList.remove('mx-expanded');
      nav.classList.add('mx-collapsed');
      toggleLink.textContent = 'Mehr anzeigen';
    } else {
      nav.classList.add('mx-expanded');
      nav.classList.remove('mx-collapsed');
      toggleLink.textContent = 'Weniger anzeigen';
    }
  });
  updateNavState();
  window.addEventListener('resize', updateNavState);
}

//Registration Functions
function mxConfirmPassword(){
    let p = document.getElementById('newCustomerPassword').value;
    let cp = document.getElementById('newCustomerPasswordConfirmation').value;
    if(p == cp){
      mxCheckPassword();
      document.getElementById("cpassword-error").classList.add('d-none');
    }else{
      document.getElementById("cpassword-error").classList.remove('d-none');
    }
  }
function mxCheckPassword(){
    let p = document.getElementById('newCustomerPassword').value;
    let cp = document.getElementById('newCustomerPasswordConfirmation').value;
    let myInput = document.getElementById("newCustomerPassword"),
        letter = document.getElementById("letter"),
        capital = document.getElementById("capital"),
        number = document.getElementById("number"),
        symbol = document.getElementById("symbol"),
        length = document.getElementById("length"),
        lowerCaseLetters = /[a-z]/g,
        upperCaseLetters = /[A-Z]/g,
        numbers = /[0-9]/g,
        symbols = /[!@#$%^&*-.,;+]/g;
  
    if(myInput.value.match(lowerCaseLetters)) {
      letter.classList.remove("invalid");
      letter.classList.add("valid");
    } else {
      letter.classList.remove("valid");
      letter.classList.add("invalid");
    }
    if(myInput.value.match(upperCaseLetters)) {
      capital.classList.remove("invalid");
      capital.classList.add("valid");
    } else {
      capital.classList.remove("valid");
      capital.classList.add("invalid");
    }
    if(myInput.value.match(numbers)) {
      number.classList.remove("invalid");
      number.classList.add("valid");
    } else {
      number.classList.remove("valid");
      number.classList.add("invalid");
    }
    if(myInput.value.match(symbols)) {
      symbol.classList.remove("invalid");
      symbol.classList.add("valid");
    } else {
      symbol.classList.remove("valid");
      symbol.classList.add("invalid");
    }
    if(myInput.value.length >= 8) {
      length.classList.remove("invalid");
      length.classList.add("valid");
    } else {
      length.classList.remove("valid");
      length.classList.add("invalid");
    }
    if(myInput.value.length >= 8 && myInput.value.match(symbols) && myInput.value.match(numbers) && myInput.value.match(upperCaseLetters) && myInput.value.match(lowerCaseLetters) && p == cp) {
      document.querySelector('#max').removeAttribute("disabled", "disabled");
    }else{
      document.querySelector('#max').setAttribute("disabled", "disabled");
    }
  }
function setupRegistration(){
  if(document.querySelector('#newCustomerPassword')){
    let password = document.querySelector('#newCustomerPassword');
    let confirmPassword = document.querySelector('#newCustomerPasswordConfirmation');

    password.onfocus = () => document.getElementById("password-error").classList.remove('d-none');
    password.onblur  = () => document.getElementById("password-error").classList.add('d-none');

    ['click','change','blur','input'].forEach( function(evt){ 
      password.addEventListener(evt, mxConfirmPassword, false);
      password.addEventListener(evt, mxCheckPassword, false);
      confirmPassword.addEventListener(evt, mxConfirmPassword, false);
    });
  }
  setTimeout(function() {
    if (document.querySelector('.frcp-cf-form--registration')) {
      document.querySelectorAll('option').forEach(option => {
        if (option.textContent.trim() === 'Krankenversicherung') {
          option.selected = true;
          option.disabled = true;
          option.textContent = '-';
        }
      });
      document.querySelector('[title="Registriere dich im Auftrag eines Unternehmens"]').onchange = function() {
        if(this.checked){
          document.querySelector('.form-control[title="Tax ID"]').required = true;
          document.querySelector('.form-control[title="Name der Firma"]').required = true;
          document.querySelector('.form-control[title="Tax ID"]').parentElement.classList.add("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.classList.add("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.style.display = 'inline-block';
          document.querySelector('.form-control[title="Tax ID"]').parentElement.style.display = 'inline-block';
        }else{
          document.querySelector('.form-control[title="Name der Firma"]').required = false;
          document.querySelector('.form-control[title="Tax ID"]').required = false;
          document.querySelector('.form-control[title="Tax ID"]').parentElement.classList.remove("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.classList.remove("frcp-cf--required");
          document.querySelector('.form-control[title="Name der Firma"]').parentElement.style.display = 'none';
          document.querySelector('.form-control[title="Tax ID"]').parentElement.style.display = 'none';
        }    
      };
      document.querySelectorAll('.frcp-cf').forEach(function (item, index) {
        if(!item.querySelector('input[type=checkbox]')){
          item.classList.remove('frcp-cf'); 
          item.classList.add('form-group'); 
        }
      });
      document.querySelectorAll('.frcp-cf__control,.vti__input,.vue-tel-input').forEach(function (item, index) {
        if(!item.parentElement.querySelector('input[type=checkbox]')){
          item.classList.remove('frcp-cf__control'); 
          item.classList.add('form-control'); 
        }
      });
      document.querySelector('.frcp-cf-btn').classList.add('btn', 'btn-theme');
      document.querySelectorAll('.frcp-cf__label').forEach(function (item, index) {
        if(!item.parentElement.querySelector('input[type=checkbox]')){
          let parent = item.parentElement.querySelector('.vue-tel-input') ? item.parentElement.querySelector('.vue-tel-input') : item.parentElement;
          parent.appendChild(item);
          item.classList.remove('frcp-cf__label'); 
          item.classList.add('label--hidden'); 
        }
      });
    }
  }, 1200);
}

//Product Template Functions
function maxTitle(){
    let Pcontent = '<div class="pricingTable"><h5 class="tableTitle">Anzahl</h5><div class="tableRow"><div class="quantityNo">1</div><div class="unitPrice premium">4,99€/Stück</div><div class="discountValue"></div></div><div class="tableRow"><div class="quantityNo">ab 10</div><div class="unitPrice premium">4.74€/Stück</div><div class="discountValue">5% Ersparnis</div></div><div class="tableRow"><div class="quantityNo">ab 25</div><div class="unitPrice premium">4.64€/Stück</div><div class="discountValue">7% Ersparnis </div></div><div class="tableRow"><div class="quantityNo">ab 50</div><div class="unitPrice premium">4.49€/Stück</div><div class="discountValue">10% Ersparnis</div></div><div class="tableRow"><div class="quantityNo">ab 100</div><div class="unitPrice premium">4.24€/Stück</div><div class="discountValue">15% Ersparnis </div></div><div class="tableRow"><div class="quantityNo">250+</div><div class="unitPrice premium">3.99€/Stück</div><div class="discountValue">20% Ersparnis </div></div></div>';
    return Pcontent;
  }
function productTemplateQuantityOffer() {
    if(document.querySelector('body').classList.contains('template-product')){
      setTimeout(function() {
        let packageOriginalPrice = parseFloat(document.querySelector('#mxProductPrice-template--23246267449675__main').textContent.replace('€','').replace(',','.'));
        let pricePercent, discountPercent = 0, Quantity = parseInt(document.querySelector('#Quantity').value);
        Quantity = isNaN(Quantity) ? 1 : Quantity; 
        if(Quantity < 10){ 
          pricePercent   = 1;
          document.querySelector('#perPerson').classList.remove("tDLT");
        }else document.querySelector('#perPerson').classList.add("tDLT");
        if(Quantity > 9) pricePercent   = .95, discountPercent = 5;
        if(Quantity > 24) pricePercent  = .93, discountPercent = 7;
        if(Quantity > 49) pricePercent  = .9,  discountPercent = 10;
        if(Quantity > 99) pricePercent  = .85, discountPercent = 15;
        if(Quantity > 249) pricePercent = .8,  discountPercent = 20;
        let newPrice = parseFloat(packageOriginalPrice * pricePercent).toFixed(2);
        let totalPrice = parseFloat(newPrice * Quantity).toFixed(2);
        document.querySelector('#changablePrice').textContent =  parseFloat(newPrice).toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
        document.querySelector('#mxTotalPrice').textContent   =  parseFloat(totalPrice).toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
        if(discountPercent != 0) document.querySelector('#discountPercent').textContent = '-'+discountPercent+'% Ersparnis';
        else if(typeof(discountPercent) != "undefined") document.querySelector('#discountPercent').textContent = '';
      }, 200);
    }
  }
function setupProductTemp() {
  productTemplateQuantityOffer();
  if(document.getElementById('info') && typeof bootstrap !== 'undefined') new bootstrap.Tooltip(document.getElementById('info'),{html: true,title: maxTitle});
  document.querySelectorAll('.js-qty__adjust').forEach(el => el.addEventListener('click', productTemplateQuantityOffer));
  document.querySelector('#mxTotalPrice').textContent = document.querySelector('#changablePrice').textContent = document.querySelector('#mxProductPrice-template--23246267449675__main').textContent;
  document.querySelector('#mxTotalPrice').textContent = parseFloat(document.querySelector('#mxTotalPrice').textContent).toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
  document.querySelector('#changablePrice').textContent = parseFloat(document.querySelector('#changablePrice').textContent).toLocaleString('de', {minimumFractionDigits: 2}) + ' €';
  document.querySelector('#mxProductPrice-template--23246267449675__main').textContent = document.querySelector('#mxProductPrice-template--23246267449675__main').textContent.toLocaleString('de', {minimumFractionDigits: 2});
  document.querySelector('#Quantity').addEventListener("input",productTemplateQuantityOffer);
}
document.addEventListener('DOMContentLoaded', () => {
  if (headerIn){
    let name = document.getElementById('userFullName').textContent;
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let initials = [...name.matchAll(rgx)] || [];
    headerIn.textContent = document.getElementById('initials').textContent =(
      (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();
  }
  if(titleWrapper){
    const viewport = titleWrapper.querySelector('.rolling-viewport');
    const list = titleWrapper.querySelector('.rolling-list'); // updated selector
    if (!viewport || !list) return;

    let items = Array.from(list.querySelectorAll('.rolling-item'));
    if (!items.length) return;

    const ORIGINAL_COUNT = items.length;
    const INTERVAL = parseInt(titleWrapper.dataset.interval || 2800, 10); 
    const TRANS_MS = parseInt(titleWrapper.dataset.transition || 600, 10);

    let index = 0;
    let timer = null;
    let paused = false;

    const clone = items[0].cloneNode(true);
    list.appendChild(clone);

    items = Array.from(list.querySelectorAll('.rolling-item'));

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(updateHeight).catch(() => setTimeout(updateHeight, 80));
    } else {
        setTimeout(updateHeight, 80);
    }
    setActiveByIndex(0);
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      list.style.transition = 'none';
      setActiveByIndex(0);
      return;
    }
    
    timer = setInterval(gotoNext, INTERVAL);

    //Moving Section Title Functions
    function updateHeight() {
      if(!items || !list) return;
      const h = items[0].offsetHeight || 0;
      viewport.style.height = h + 'px';
      list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
      list.style.transform = `translateY(-${index * h}px)`;
    }
    function setActiveByIndex(i) {
      if(!items || !ORIGINAL_COUNT) return;
      const activeIdx = i % ORIGINAL_COUNT;
      for (let j = 0; j < ORIGINAL_COUNT; j++) {
        items[j].classList.toggle('is-active', j === activeIdx);
      }
    }
    function gotoNext() {
      if (paused || !items || !list) return;
      index++;
      const h = items[0].offsetHeight || 0;
      list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
      list.style.transform = `translateY(-${index * h}px)`;
      setActiveByIndex(index);
                
      setTimeout(() => {
        if (index >= ORIGINAL_COUNT) {
          list.style.transition = 'none';
          index = 0;
          list.style.transform = `translateY(0px)`;
          setActiveByIndex(index);
          requestAnimationFrame(() => {
            list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
          });
        }
      }, TRANS_MS);
    }
    
    titleWrapper.addEventListener('mouseenter', () => { paused = true; });
    titleWrapper.addEventListener('mouseleave', () => { paused = false; });
    titleWrapper.addEventListener('focusin', () => { paused = true; });
    titleWrapper.addEventListener('focusout', () => { paused = false; });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        list.style.transition = 'none';
        index = index % ORIGINAL_COUNT;
        updateHeight();
        resizeTimer = setTimeout(() => {
        list.style.transition = `transform ${TRANS_MS}ms cubic-bezier(.2,.9,.2,1)`;
        }, 80);
    });
  }
  if(tabWrapper){
    document.addEventListener('click', function (e) {
      const navItem = e.target.closest('.nav-link');
      if (!navItem) return; // Not a nav item

      // Scroll to the content wrapper
      const offset = wrapper.getBoundingClientRect().top + window.scrollY - 70;  
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  }
  if (bodyClasses.contains('template-index'))              setupHP();
  if (bodyClasses.contains('template-customers-register')) setupRegistration();
  if (bodyClasses.contains('template-product'))            setupProductTemp();
});